import productcategories from "./productcategories"
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    appLocale : "en",
    de : {

    },
    en : {
        clear_button : "Clear",
        placeholder : {
            order_number : "Order Number",
        }
    }
})

  // getters
  const getters = {
    labels : (state) => () => {
        return state[state.appLocale];
    }
  }

  // actions
  const actions = {

  }

  // mutations
  const mutations = {
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
  }
}
